import { Component, OnInit } from '@angular/core';
import { Input, ViewEncapsulation } from '@angular/core';
import moment from 'moment';
import { finalize, tap } from 'rxjs';
import { Appointment } from 'src/models/appointment';
import { User } from 'src/models/user';
import { Workshop } from 'src/models/workshop';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { APIService } from 'src/services/api-services/api-service';
import { APIServiceSchedule } from 'src/services/api-services/api-service-schedule';
import { APIUserDealerService } from 'src/services/api-services/api-user-dealer';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { HelperService } from 'src/services/helperService';
import { TranslateService } from '@ngx-translate/core';
import { dashboardDateService } from 'src/services/dashboardDateService.service';
import { DashboardIncadeaService } from 'src/services/api-services/dashboardIncadeaBooking.service';
import { MyCalendaryIncadea } from 'src/services/api-services/api-interfaces/api-interface-incadea-Mycalendary';

@Component({
    selector: 'app-i-calendar',
    templateUrl: './i-calendar.component.html',
    styleUrls: ['./i-calendar.component.sass'],
    standalone: false
})
export class ICalendarComponent implements OnInit {
  customScheduleResp!: MyCalendaryIncadea[];
  isLoading: boolean = true;
  @Input() years: string[] = [];
  @Input() isCalendarCollapsed: boolean = false;
  selectedMonth: number = 0;
  days: number[] = new Array<number>(5);
  selectedDay: number = 0;
  selectedDayMonth: number = 0;
  currentYear: number = 0;
  daysInSelectedMonth: number = 0;
  message='Mensaje enviado'
  fecha: Date = new Date();
  startWeek: string=''
  endWeek: string=''
  UserDealersData: any[] = [];
  workshopsData: Workshop[] = [];
  client: any[] = [];
  appointmentsData: any[] = [];
  weekInEs: string[] = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  userProfile?: User;


  constructor(
    public ScheduleService: APIServiceSchedule,
    public Service: APIService,
    public customerbasicdataService: APICustomerBasicDataService,
    public WorkshopService: APIWorkshopService,
    public schedulerService: APISchedulerService,
    public customScheduleService: APICustomScheduleService,
    public helperService: HelperService,
    public UserDealerservice: APIUserDealerService,
    public DashboardService: DashboardIncadeaService,
    public date: dashboardDateService,
    private translate: TranslateService
  ) {
     ;
  }
  ngOnInit(): void {
    this.userProfile = this.helperService.user;
    this.getCalendar();
    let currentDate = moment();
    this.selectedMonth = currentDate.month() + 1;
    this.selectedDayMonth = this.selectedMonth;
    this.currentYear = currentDate.year();
    this.selectedDay = currentDate.date();
    this.setDisplayedDays(this.selectedDay);
    this.sendMonth(this.years[this.selectedMonth - 1])
  }
  getCalendar() {
    this.DashboardService?.getIBMyCalendary(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.userid)
    .pipe(tap(answer=>{
      if(!answer.message){
        this.customScheduleResp=answer
          this.customScheduleResp = answer.sort(
            (a: Appointment, b: Appointment) => a.time.localeCompare(b.time)
          );
          this.data_change()
      }
      else{
        this.data_change()
      }
    }))
    .subscribe({
      error: (error) => {
        // Validation 401 error
        if(error.status === 401){
          this.helperService.logoutToken()
        }
      }
    });
}


  data_change() {
    var today = new Date();
    var now = today.getHours();

    this.onDayClick(this.selectedDay);
  }

  isClearDisabled(): boolean {
    // function to enable clear button conditionally
    let isDisabled = true;

    if (this.appointmentsData.length <= 5) {
      //if any filter is filled the button will be enabled
      isDisabled = false;
    }
    return isDisabled;
  }


  prevMonth() {
    if (this.selectedMonth > 0) {
      this.selectedMonth--;
      this.setDisplayedDays(3);
      const monthName=this.years[this.selectedMonth - 1]
      this.sendMonth(monthName)
    }
  }
    getWeekPositionMonthBased(day: number, week:number,month:string,) {
    // 0 for start - 6 for end
      const today = new Date();
      const dayOfWeek = today.getDay();
      const diff = today.getDate() + (day - dayOfWeek) + (dayOfWeek === 0 ? -6 : 1);
      return new Date(today.setDate(diff)).toISOString().split('T')[0];
    }

  nextMonth() {
    if (this.selectedMonth < this.years.length) {
      this.selectedMonth++;
      this.setDisplayedDays(3);
      const monthName=this.years[this.selectedMonth - 1]
      this.sendMonth(monthName)

    }
  }
  sendMonth(monthName:string) {
    this.date.changeMessage(monthName);
  }
  isDayOfTheMonthValid(day: number): boolean {
    return moment(
      `${this.currentYear}-${this.selectedMonth}-${day}`,
      'YYYY-MM-DD'
    ).isValid();
  }
  setDisplayedDays(day: number) {
    //Re-calibrate displayed day in the middle
    if (!this.isDayOfTheMonthValid(day - 1)) {
      day = day + 2;
    }
    if (!this.isDayOfTheMonthValid(day - 2)) {
      day = day + 1;
    }

    if (!this.isDayOfTheMonthValid(day + 1)) {
      day = day - 1;
    }
    if (!this.isDayOfTheMonthValid(day + 2)) {
      day = day - 1;
    }

    this.days[0] = day - 2;
    this.days[1] = day - 1;
    this.days[2] = day;
    this.days[3] = day + 1;
    this.days[4] = day + 2;

    this.daysInSelectedMonth = moment(
      `${this.currentYear}-${this.selectedMonth}`,
      'YYYY-MM'
    ).daysInMonth();
  }

  getDayOfWeekInEs(
    day: number,
    month: number,
    isSliced: boolean = false
  ): string {
    let dayOfWeek = moment(
      `${this.currentYear}-${month}-${day}`,
      'YYYY-MM-DD'
    ).day();
    return isSliced
      ? this.weekInEs[dayOfWeek].slice(0, 2)
      : this.weekInEs[dayOfWeek];
  }

  prevWeek() {
    if (this.days[0] - 1 > 0) {
      this.days.forEach((day, index) => {
        this.days[index] = day - 1;
      });
    }
  }

  nextWeek() {
    if (this.days[4] + 1 <= this.daysInSelectedMonth) {
      this.days.forEach((day, index) => {
        this.days[index] = day + 1;
      });
    }
  }

  onDayClick(day: number) {
    this.isLoading = true;
    this.selectedDay = day;
    this.selectedDayMonth = this.selectedMonth;
    let date = new Date(
      this.selectedMonth + '/' + this.selectedDay + '/' + this.currentYear
    );

        this.appointmentsData = [];
        this.appointmentsData = this.customScheduleResp.filter(
          (s) =>
            new Date(s.date).toLocaleDateString() === date.toLocaleDateString()
        );

        console.log(day,date.toLocaleDateString(),this.appointmentsData)
    this.isLoading = false;
    this.isClearDisabled();
  }
}
